import {Descriptions} from 'antd';
import React, {FC} from 'react';

import {IDirectoryEntityMeta} from 'entities/metadata';
import {TEntity} from 'modules/data';

import {directoryItemDescriptionTypeResolver} from './directory-item-description-type-resolver';

interface IDirectoryItemDescriptionProps {
    data: TEntity;
    metadata: IDirectoryEntityMeta;
}

export const DirectoryItemDescription: FC<IDirectoryItemDescriptionProps> = ({
    data,
    metadata,
}: IDirectoryItemDescriptionProps) => (
    <div>
        <Descriptions
            bordered
            size="middle"
            column={1}
        >
            {metadata.fields.map(field => (
                directoryItemDescriptionTypeResolver(field, data)
            ))}
        </Descriptions>
    </div>
);
